import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CustomTextfield } from '../../textfield/CustomTextField'
import AutocompleteCountries from '../../textfield/AutocompleteCountries'
import styles from './Dialogs.module.scss'

interface IProps {
  open: boolean
  handleOpen: () => void
  handleConfirm: (newCountry: string, reason: string) => void
  dialogTitle: string
  currentCountry?: string
}

export const ChangeCountryDialog = (props: IProps) => {
  const { open, handleOpen, handleConfirm, dialogTitle, currentCountry } = props

  const [selectedCountry, setSelectedCountry] = useState<{ label?: string, value?: string }>({
    label: '',
    value: ''
  })
  const [reason, setReason] = useState<string>('')
  const [error, setError] = useState(false)

  const { t } = useTranslation()

  const handleSave = () => {
    if (!selectedCountry?.value || !reason) {
      setError(true)
    } else {
      handleConfirm(selectedCountry.value, reason)
      // Reset form
      setSelectedCountry({ label: '', value: '' })
      setReason('')
      setError(false)
    }
  }

  const handleCancel = () => {
    // Reset form on cancel
    setSelectedCountry({ label: '', value: '' })
    setReason('')
    setError(false)
    handleOpen()
  }

  return (
    <Dialog open={open} onClose={handleCancel}>
      <Alert severity='info'>
        {t('message_disclaimer_country')}<br />{t('message_disclaimer_country2')}
      </Alert>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <div className={styles.content}>
          <AutocompleteCountries
            selectedCountry={selectedCountry}
            size='small'
            className={styles.textfield}
            setSelectedCountry={setSelectedCountry}
            isRequired
          />
          
          <CustomTextfield
            className={styles.textfield}
            size='small'
            name='reason'
            multiline
            rows={3}
            variant='outlined'
            label={t('reason')}
            value={reason}
            onChange={(event: any) => {
              setReason(event.currentTarget.value)
            }}
          />
          
          {error && (
            <Typography color="primary">
              {t('All fields are required')}
            </Typography>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} className={styles.cancelButton}>
          {t('Cancel')}
        </Button>
        <Button onClick={handleSave} className={styles.confirmButton}>
          {t('Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}